import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const WORKDAY = () => {
  return (
    <CardSection id="WORKDAY" title="WORKDAY">
      <Paragraph>
        날짜(시작 날짜) 전후에 지정된 근무일 수인 날짜를 나타내는 숫자를
        반환합니다. 이는 Excel의 WORKDAY 함수와 동일한 출력을 제공합니다. 송장
        만기일, 예상 배송 시간 또는 수행된 작업 일수를 계산할 때 주말을
        제외하려면 WORKDAY를 사용하세요.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>WORKDAY(STARTDATE, DAYS)</Paragraph>
        <Ul>
          <Li>
            <b>STARTDATE</b>는 시작 날짜를 나타내는 날짜입니다.
          </Li>
          <Li>
            <b>DAYS</b>는 시작 날짜 전후의 비주말 일수입니다. 일수에 대한 양수
            값은 미래 날짜를 생성합니다. 음수 값은 과거 날짜를 생성합니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>현재 지원 준비중인 함수입니다.</Paragraph>
      </ListSection>
    </CardSection>
  );
};
